import store from '@/store';

class ThemeManager {
  constructor() {
    this.THEME_KEY = 'theme';
    this.DEFAULT_THEME = 'light'; // 默认暗色主题
  }
  
  // 初始化主题
  init() {
    const theme = this.getCurrentTheme();
    this.applyTheme(theme);
  }
  
  // 获取当前主题
  getCurrentTheme() {
    // 首先从Vuex状态获取
    const preferences = store.getters.userPreferences || {};
    if (preferences[this.THEME_KEY]) {
      return preferences[this.THEME_KEY];
    }
    
    // 然后从localStorage获取
    try {
      const storedPrefs = localStorage.getItem('preferences');
      if (storedPrefs) {
        const prefs = JSON.parse(storedPrefs);
        if (prefs && prefs[this.THEME_KEY]) {
          return prefs[this.THEME_KEY];
        }
      }
    } catch (e) {
      console.warn('解析存储的偏好设置失败:', e);
    }
    
    // 返回默认主题
    return this.DEFAULT_THEME;
  }
  
  // 应用主题
  applyTheme(theme) {
    const app = document.getElementById('app');
    if (app) {
      if (theme === 'light') {
        app.classList.remove('dark-theme');
        app.classList.add('light-theme');
      } else {
        app.classList.remove('light-theme');
        app.classList.add('dark-theme');
      }
    }
    
    // 触发自定义事件，通知其他组件主题已更改
    window.dispatchEvent(new CustomEvent('themeChanged', { detail: { theme } }));
  }
  
  // 更新主题
  async updateTheme(newTheme) {
    try {
      // 更新用户偏好设置
      await store.dispatch('auth/updateUserPreference', { 
        key: this.THEME_KEY, 
        value: newTheme 
      });
      
      // 应用新主题
      this.applyTheme(newTheme);
      
      return { success: true };
    } catch (error) {
      console.error('更新主题失败:', error);
      return { success: false, error };
    }
  }
}

export default new ThemeManager();